import { SELECTED_ORG_ID, SELECTED_ORG_NAME } from '@/configs/storageKeys';

export function clearSelectedOrganisation() {
  window.localStorage.removeItem(SELECTED_ORG_ID);
  window.localStorage.removeItem(SELECTED_ORG_NAME);
  window.sessionStorage.removeItem(SELECTED_ORG_ID);
  window.sessionStorage.removeItem(SELECTED_ORG_NAME);
}

export function storeSelectedOrganisation(orgId: number, orgName: string) {
  // used for users mavigating from home to dashboard to load the last selected org
  window.localStorage.setItem(SELECTED_ORG_ID, String(orgId));
  window.localStorage.setItem(SELECTED_ORG_NAME, orgName);

  // used to select the org inside the current tab
  window.sessionStorage.setItem(SELECTED_ORG_ID, String(orgId));
  window.sessionStorage.setItem(SELECTED_ORG_NAME, orgName);

  // dispatch for current tab only
  window.dispatchEvent(
    new CustomEvent('localStorageChange', {
      detail: { key: 'selectedOrganisationName', newValue: orgName },
    }),
  );
}
